/** @jsxImportSource @emotion/react */

import React from 'react';
import styled from 'styled-components';
import TextBlock from '@component/common/block/text-block';
import * as color from '@constant/color';
import * as size from '@constant/size';
import { ETheme } from '@datatype/type';

interface IProps {
  theme: ETheme;
  selected?: boolean;
  width?: string;
  height?: string;
  // 굵은 제목. 생략하면 value만 노출
  label?: string;
  // 보조 텍스트. 생략하면 label만 노출 (온보딩 유입경로처럼 설명 없는 선택지)
  value?: string;
  // 텍스트 정렬. 학습설정 모달처럼 짧은 값은 center, 온보딩처럼 문장형은 left
  align?: 'left' | 'center';
  handleClick?: () => void;
}

const Wrapper = styled.div<{
  $selected: boolean;
  $height: string;
  $width: string;
  $borderColor: string;
  $isCenter: boolean;
  $align: 'left' | 'center';
}>`
  display: flex;
  flex-flow: column nowrap;
  justify-content: ${(props) => (props.$isCenter ? 'center' : 'space-between')};
  align-items: ${(props) => (props.$align === 'left' ? 'flex-start' : 'center')};
  padding: ${(props) => (props.$align === 'left' ? '10px' : '5px 0px')};
  height: ${(props) => props.$height};
  border-radius: ${size.BORDER_RADIUS_2};
  border: ${size.BORDER_WIDTH_1} solid
    ${(props) => (props.$selected ? props.$borderColor : color.GRAY_BOX_BORDER_COLOR)};
  width: ${(props) => props.$width};
  box-sizing: border-box;

  &:hover {
    box-shadow: ${color.HOVER_SHADOW};
    transform: ${size.HOVER_TRANSLATE};
  }

  cursor: pointer;
`;

const createDesign = (theme: ETheme) => {
  let themeColor;
  switch (theme) {
    case ETheme.BROWN:
      themeColor = color.BROWN_1;
      break;
    default:
      themeColor = color.BROWN_1;
      break;
  }

  return { color: themeColor };
};

const Option: React.FC<IProps> = ({
  theme,
  label,
  value,
  width = 'fit-content',
  height = 'auto',
  align = 'center',
  selected = false,
  handleClick,
}) => {
  const { color: selectedColor } = createDesign(theme);
  const alignX = align === 'left' ? 'left' : 'center';

  return (
    <Wrapper
      $selected={selected}
      $height={height}
      $width={width}
      $borderColor={selectedColor}
      $isCenter={!label || !value}
      $align={align}
      onClick={handleClick}>
      {label && (
        <TextBlock
          text={label}
          design={{ text: { size: 'medium', color: color.BLACK_2, bold: true }, box: { alignX } }}
        />
      )}
      {value && (
        // <TextBlock text={value} design={{ text: { size: 'medium', color: color.BLACK_2 }, box: { alignX } }} />
        <TextBlock text={value} design={{ text: { size: 'medium', color: color.BLACK_4 }, box: { alignX } }} />
      )}
    </Wrapper>
  );
};

export default Option;
